<template>
    <div>
        <fieldset :disabled="formDisabled">
            <loader v-show="isLoading" />
            <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="structureObjectForm" v-show="!isLoading">
                <div class="row">
                    <div class="col-sm-3">
                        <h4>Attachment {{structureDto.attachmentNumber}} of {{attachmentCount}} </h4>
                    </div>
                    <div class="col-sm-4">
                        <label>Attachment ID:</label> {{structureDto.dbNumber}}
                    </div>
                </div>
                <div v-if="qaqcEnabled" class="row" style="margin-bottom: 20px;">
                    <label class="col-md-3">Attachment Selection:</label>
                    <div class="col-md-7">
                        <select class="form-control" v-model="qaqcSelection.attachmentSelection">
                            <option disabled :value="-1">Attachment Selection</option>
                            <option :value="0">Add As New Production Attachment</option>
                            <option v-for="attachment in productionAttachmentList" :value="attachment.structureObjectFormId">Update Production Attachment: {{attachment.dbNumber}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.historicName') }">
                    <label class="col-md-2 control-label text-label">Historic Name</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.historicName" name="historicName" v-validate="'required'">
                        <span v-show="errors.has('structureObjectForm.historicName')" class="has-error">{{ errors.first('structureObjectForm.historicName') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicName'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Other Common Names</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.otherCommonNames" >
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'otherCommonNames'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.structureType') }">
                    <label class="col-md-2 control-label text-label">Type of Structure/Object</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.structureType" name="structureType" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.structureType')" class="has-error">{{ errors.first('structureObjectForm.structureType') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'structureType'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Associated Resources</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.associatedResources" >
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'associatedResources'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Construction History</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'constructionDateList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Estimated</th>
                                    <th>Comment</th>
                                    <th>Source</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(date, index) in constructionDates">
                                    <td>{{date.constructionDateTypeDescription}}</td>
                                    <td>{{date.date}}</td>
                                    <td>{{date.isEstimate ? 'Yes' : 'No'}}</td>
                                    <td>{{date.comment}}</td>
                                    <td>{{date.source}}</td>
                                    <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeConstructionDate(index)"></a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="!formDisabled" class="form-group">
                    <div class="col-md-1 col-md-offset-10">
                        <button class="form-contol btn" v-on:click="$refs['constructionDateModal'].open()">Add Construction Dates</button>
                    </div>
                </div>
                <modal ref="constructionDateModal">
                    <div slot="header" class="row">
                        <h3 class="pull-left">Construction Dates</h3>
                        <button class="btn pull-right" v-on:click="$refs['constructionDateModal'].close()">X</button>
                    </div>
                    <div slot="body">
                        <form v-on:submit.prevent data-vv-scope="constructionForm">
                            <div class="form form-horizontal">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.constructionDateTypeId') }">
                                    <label class="col-md-4 control-label">Date type</label>
                                    <div class="col-md-8">
                                        <select class="form-control" v-model="constructionDateDto.constructionDateTypeId" name="constructionDateTypeId" v-validate="{ required: !structureDto.isNonExtant }">
                                            <option disabled value="">Select a value</option>
                                            <option  v-for="dateType in constructionDateTypes" :value="dateType.constructionDateTypeId">
                                                {{dateType.description}}
                                            </option>
                                        </select>
                                        <span v-show="errors.has('constructionForm.constructionDateTypeId')" class="has-error">Required</span>
                                    </div>
                                </div>

                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.date') }">
                                    <label class="col-md-4 control-label">Date</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="constructionDateDto.date" name="date" v-validate="{ required: !structureDto.isNonExtant }">
                                        <span v-show="errors.has('constructionForm.date')" class="has-error">Required</span>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label class="col-md-4 control-label">Estimated</label>
                                    <div class=" col-md-2">
                                        <div class="checkbox checkbox-inline" style="padding-top:0px">
                                            <input :id="qaqcFieldId + 'sofEstimateCB'" type="checkbox" v-model="constructionDateDto.isEstimate" >
                                                <label :for="qaqcFieldId + 'sofEstimateCB'">&nbsp;</label>
                                            </input>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.comment') }">
                                    <label class="col-md-4 control-label">Comment</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="constructionDateDto.comment" name="comment" v-validate="{ required: !structureDto.isNonExtant }">
                                        <span v-show="errors.has('constructionForm.comment')" class="has-error">Required</span>
                                    </div>
                                </div>

                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.source') }">
                                    <label class="col-md-4 control-label">Source</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="constructionDateDto.source" name="source" v-validate="{ required: !structureDto.isNonExtant }">
                                        <span v-show="errors.has('constructionForm.source')" class="has-error">Required</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div slot="footer">
                        <div class="row">
                                <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="constructionDatesDone()">Done</button>
                                <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="constructionDatesMore()">More</button>
                        </div>
                    </div>
                </modal>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.architectBuilder') }">
                    <label class="col-md-2 control-label text-label">Architect(s)/Builder(s)</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.architectBuilder" name="architectBuilder" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.architectBuilder')" class="has-error">{{ errors.first('structureObjectForm.architectBuilder') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'architectBuilder'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.historicFunctions') }">
                    <label class="col-md-2 control-label text-label">Historic Function(s)</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.historicFunctions" name="historicFunctions" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.historicFunctions')" class="has-error">{{ errors.first('structureObjectForm.historicFunctions') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicFunctions'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.alterations') }">
                    <label class="col-md-2 control-label text-label">Alterations</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.alterations" name="alterations" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.alterations')" class="has-error">{{ errors.first('structureObjectForm.alterations') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'alterations'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.currentUses') }">
                    <label class="col-md-2 control-label text-label">Current use(s)</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.currentUses" name="currentUses" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.currentUses')" class="has-error">{{ errors.first('structureObjectForm.currentUses') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'currentUses'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.historicUses') }">
                    <label class="col-md-2 control-label text-label">Historic use(s)</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.historicUses" name="historicUses" v-validate="{ required: !structureDto.isNonExtant }">
                        <span v-show="errors.has('structureObjectForm.historicUses')" class="has-error">{{ errors.first('structureObjectForm.historicUses') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicUses'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.description') }">
                    <label class="col-md-2 control-label text-label">Description</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'description'" :hasAppend="true"></qaqcFormFieldSelect>
                        <textarea class="form-control" rows="6" v-model="structureDto.description" name="description" v-validate="{ required: !structureDto.isNonExtant }" />
                        <span v-show="errors.has('structureObjectForm.description')" class="has-error">{{ errors.first('structureObjectForm.description') }}</span>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.constructionMaterials') }">
                    <label class="col-md-2 control-label text-label">Construction Materials</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.constructionMaterials" name="constructionMaterials" v-validate="{ required: !structureDto.isNonExtant }" />
                        <span v-show="errors.has('structureObjectForm.constructionMaterials')" class="has-error">{{ errors.first('structureObjectForm.constructionMaterials') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'constructionMaterials'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('structureObjectForm.styleType') }">
                    <label class="col-md-2 control-label text-label">Style/Type</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="structureDto.styleType" name="styleType" v-validate="{ required: !structureDto.isNonExtant }" />
                        <span v-show="errors.has('structureObjectForm.styleType')" class="has-error">{{ errors.first('structureObjectForm.styleType') }}</span>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'styleType'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Additional Narrative</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'additionalNarrative'" :hasAppend="true"></qaqcFormFieldSelect>
                        <textarea class="form-control" rows="6" v-model="structureDto.additionalNarrative"/>
                    </div>
                </div>
                <div class="form-group" style="margin-top: 10px;">
                    <label class="col-md-2 control-label text-label"></label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'isNonExtant'" :hasAppend="false"></qaqcFormFieldSelect>
                        <input style="width: 20px; height: 20px;" type="checkbox" v-model="structureDto.isNonExtant" :id="qaqcFieldId + 'sofIsNonExtant'" />
                        <label class="control-label text-label" style="font-size: 12px;" :for="qaqcFieldId + 'sofIsNonExtant'">Non-Extant</label>
                    </div>
                </div>
            </form>
        </fieldset>
        <div>
            <div class="form-group">
                <hr>
                <div class="row" style='margin-left:10px'>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" style="margin-left:10px" v-on:click="previousStructureObject" :disabled="currentAttachmentNumber === 1">Previous</button>
                    </div>
                    <div v-if="!(formDisabled)" class="col-xs-4 text-center">
                        <button class="btn btn-primary" :disabled="formDisabled" v-on:click="qaqcEnabled ? completeSection('structureObject') : saveStructureObject()">Save</button>
                    </div>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" v-on:click="nextStructureObject" :disabled="dtoIsNew || currentAttachmentNumber >= attachmentCount">Next</button>
                    </div>
                </div>
                <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'structureObject'" :completeSection="completeSection"></qaqcFormFieldFooter>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import modal from '../Modal.vue'
import structureObjectFormService from '../../services/siteForm/structureObjectFormService'
import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import loader from '@/components/Loader.vue'

export default {
    name: 'historicStructureForm',
    components: {
        modal,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter,
        loader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            structureDto: {
            },
            constructionDateDto: {
            },
            constructionDates: [],
            constructionDateTypes: [
                {constructionDateTypeId: 1, description: 'Construction Date'},
                {constructionDateTypeId: 2, description: 'Moved Date'},
                {constructionDateTypeId: 3, description: 'Altered Date'}
            ],
            currentAttachmentNumber: 1,
            productionAttachmentList: []
        }
    },
    props: {
        attachmentCount: {},
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        productionCrrId: { default: null },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no structureObject or structureObjectSelection qa/qc objects, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.structureObject || this.qaqcProgressDto.qaqcSelections.structureObject.length === 0) {
                //     this.qaqcProgressDto.qaqcSelections.structureObject = []
                //     for (var i = 0; i < this.attachmentCount; i++) {
                //         this.qaqcProgressDto.qaqcSelections.structureObject.push(qaqcService.structureObjectSelection())
                //     }
                // }

                // more selections than counts, remove extras
                if (this.qaqcProgressDto.qaqcSelections.structureObject.length > this.attachmentCount) {
                    let difference = this.qaqcProgressDto.qaqcSelections.structureObject.length - this.attachmentCount
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.structureObject.pop()
                    }
                }
                // more counts than selections, add more
                if (this.qaqcProgressDto.qaqcSelections.structureObject.length < this.attachmentCount) {
                    let difference = this.attachmentCount - this.qaqcProgressDto.qaqcSelections.structureObject.length
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.structureObject.push(qaqcService.structureObjectSelection())
                    }
                }
                // return the attachment number's selection in the structureObject array
                var selection = this.qaqcProgressDto.qaqcSelections.structureObject[this.currentAttachmentNumber - 1] || qaqcService.structureObjectSelection()
                if (!selection.isNonExtant) selection.isNonExtant = 0
                return selection
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        },
        dtoIsNew: function () {
            return !this.structureDto.structureObjectFormId || this.structureDto.structureObjectFormId === 0
        }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadData().then(result => {
                this.loadLookups()
                this.isLoading = false
            })
        },
        productionCrrId: function (val) {
            this.log('productionCrrId is changed: ' + val)
            this.loadProductionAttachments()
        }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId) {
            this.loadData().then(result => {
                this.loadLookups()
                if (this.productionCrrId) {
                    this.loadProductionAttachments()
                }
                this.isLoading = false
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Structure/Object Form', message)
        },
        loadData () {
            var crrId = this.crrId
            this.log('Searching for assemblage for crr: ' + crrId)
            return structureObjectFormService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                if (result.data.length > 0 && result.data.find(x => { return x.attachmentNumber === this.currentAttachmentNumber })) {
                    //load the current attachment number data
                    this.structureDto = result.data.find(x => { return x.attachmentNumber === this.currentAttachmentNumber })
                    //set formId to qaqcSelection
                    if (this.qaqcEnabled) {
                        this.qaqcSelection.currentFormId = this.structureDto.structureObjectFormId
                    }
                    //reset constructionDates
                    this.constructionDates = []
                    this.constructionDates = this.structureDto.constructionDateList
                    // populate the date type description
                    this.constructionDates.forEach(date => {
                        var val = this.constructionDateTypes.find(x => {
                            return x.constructionDateTypeId === date.constructionDateTypeId
                        })
                        date.constructionDateTypeDescription = val ? val.description : ''
                    })
                } else {
                    this.createStructureDto()
                    this.log('Nothing found')
                }
                return result
            })
        },
        loadLookups () {
        },
        createStructureDto () {
            this.constructionDates = []
            this.structureDto = {}
            this.structureDto = {
                culturalResourceRecordingId: this.crrId,
                attachmentNumber: this.currentAttachmentNumber
            }
        },
        constructionDatesDone () {
            this.log('id : ' + this.constructionDateDto.constructionDateTypeId)
            this.$validator.validateAll('constructionForm').then(result => {
                if (result) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val ? val.description : ''
                    this.constructionDates.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                    this.$refs.constructionDateModal.close()
                }
            })
        },
        constructionDatesMore () {
            this.$validator.validateAll('constructionForm').then(result => {
                if (result) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val ? val.description : ''
                    this.constructionDates.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                }
            })
        },
        saveStructureObject () {
            this.isLoading = true
            return new Promise(resolve => {
                this.$validator.validateAll('structureObjectForm').then(valResult => {
                    if (valResult) {
                        this.structureDto.constructionDateList = this.constructionDates.map(x => {
                            x.structureObjectFormId = this.structureDto.structureObjectFormId || 0
                            return x
                        })
                        this.log('CRR id: ' + this.structureDto.culturalResourceRecordingId)
                        structureObjectFormService.put(this.$http, this.structureDto).then(result => {
                            this.structureDto.structureObjectFormId = result.data.objectList[0].structureObjectFormId
                            this.loadData()
                            this.isLoading = false
                            resolve(result)
                        })
                    } else {
                        this.log('invalid form')
                        this.isLoading = false
                        resolve(1)
                    }
                })
            })
        },
        previousStructureObject () {
            --this.currentAttachmentNumber
            this.log(`Loading previous: ${this.currentAttachmentNumber}`)
            this.loadData().then(x => {
                this.errors.clear('structureObjectForm')
            })
        },
        nextStructureObject () {
            ++this.currentAttachmentNumber
            this.log(`Loading next: ${this.currentAttachmentNumber}`)
            this.loadData().then(x => {
                this.errors.clear('structureObjectForm')
            })
        },
        removeConstructionDate (index) {
            this.constructionDates.splice(index, 1)
        },
        checkSelectionComplete (selection) {
            for (let key in selection) {
                if ((String(key) === 'attachmentSelection' && selection[key] === -1) || (String(key) !== 'attachmentSelection' && selection[key] === 0)) {
                    return false
                }
            }
            return true
        },
        completeSection (sectionName) {
            this.saveStructureObject().then(response => {
                if (!this.structureDto.structureObjectFormId) {
                    alert('Form has not been saved. Cannot complete section.')
                    return
                }
                this.qaqcSelection.currentFormId = this.structureDto.structureObjectFormId
                //check if all selections have been made
                if (this.qaqcSelection.attachmentSelection === -1) {
                    alert('Please complete Attachment Selection')
                    return
                }
                if (!this.checkSelectionComplete(this.qaqcSelection)) {
                    alert('Please complete all QA/QC selections in this section.')
                    return
                }
                var sectionComplete = true
                //check if the other historicBuilding selections have been complete
                this.qaqcProgressDto.qaqcSelections.structureObject.forEach(selection => {
                    if (!this.checkSelectionComplete(selection)) { sectionComplete = false }
                })
                this.saveQaqcProgress(sectionName, sectionComplete)
            })
        },
        loadProductionAttachments () {
            this.productionAttachmentList = []
            return structureObjectFormService.search(this.$http, {culturalResourceRecordingId: this.productionCrrId}).then(result => {
                result.data.forEach(attachment => {
                    this.productionAttachmentList.push(attachment)
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// HistoricStructureObjectForm.vue?05cff19a